const courses = {
    memberList: [],
    currentGuideItem: null,
    discount: 0,
    feedback: null,
    hasDates:true,
};

export default courses;